const NField = require('./nfield');

module.exports = class NString extends NField {

};
